import React, { Component } from 'react';
import { LocalizedTheme } from '@philips-internal/oswald-ui-constants';
import { ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { classNames, getSlot, isEnumValid, isFunction, isTouchableDevice, noop } from '@philips-internal/oswald-ui-utils';
import { HeadingContext } from '../heading-context/heading-context.js';
import { HeadingProperties } from './heading-types.js';
import './heading.css';
const HeadingContentContainer = {
    acceptedTypes: [
        ComponentType.AGGREGATOR,
        ComponentType.BEHAVIOR,
        ComponentType.DATA_DISPLAY,
        ComponentType.FORM,
        ComponentType.LAYOUT,
        ComponentType.LIST,
        ComponentType.NAVIGATION,
    ],
    name: 'content',
};
class Heading extends Component {
    constructor() {
        super(...arguments);
        this.unlistenCustomClassName = noop;
    }
    componentDidMount() {
        this.unlistenCustomClassName = this.getContext().addCustomClassNameListener(() => this.forceUpdate());
        this.getContext().setTitle(this.props.title);
    }
    componentDidUpdate(prevProps) {
        const { title } = this.props;
        if (prevProps.title !== title) {
            this.getContext().setTitle(title);
        }
    }
    componentWillUnmount() {
        if (isFunction(this.unlistenCustomClassName)) {
            this.unlistenCustomClassName();
        }
    }
    getContext() {
        if (!this.context) {
            throw Error('[Heading]: No context provided');
        }
        return this.context;
    }
    renderChildren(containerClassName, collapsed) {
        const { children, container = {}, uuid = HeadingProperties.uuid.defaultValue } = this.props;
        if (collapsed) {
            return getSlot(children, 'actions');
        }
        return (React.createElement(Container, { acceptedTypes: container.acceptedTypes ?? HeadingContentContainer.acceptedTypes, className: containerClassName, slot: container.name ?? HeadingContentContainer.name, uuid: uuid }, children));
    }
    getClassName(baseClass) {
        const { className, theme } = this.props;
        const context = this.getContext();
        const customClassName = context.getCustomClassName();
        return classNames({
            [`${baseClass}`]: true,
            [`${baseClass}--${theme}`]: isEnumValid(LocalizedTheme, theme),
            [`${baseClass}--touchable-device`]: isTouchableDevice(),
            [`${className}`]: Boolean(className),
            [`${customClassName}`]: Boolean(customClassName),
        });
    }
    render() {
        return null;
    }
}
Heading.contextType = HeadingContext;
export { Heading, HeadingContentContainer, };
//# sourceMappingURL=heading.js.map